import { Routes } from '@angular/router';
import { canMatchByModule } from './core/rbac/rbac-route.guard';
import { environment } from '../environments/environment';

const developmentRoutes: Routes = environment.showDevelopmentScreens
  ? [
      {
        path: 'component-screen',
        canMatch: [canMatchByModule('components-screen')],
        loadChildren: () => import('./features/components-screen/components-screen.routes').then((m) => m.componentsScreenRoutes)
      },
      {
        path: 'components-screen',
        redirectTo: 'component-screen',
        pathMatch: 'full'
      }
    ]
  : [];

export const appRoutes: Routes = [
  {
    path: 'login',
    loadComponent: () => import('./features/login/login.component').then((m) => m.LoginComponent)
  },
  {
    path: '',
    loadComponent: () => import('./layout/shell/shell.component').then((m) => m.ShellComponent),
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: 'dashboard'
      },
      {
        path: 'dashboard',
        canMatch: [canMatchByModule('dashboard')],
        loadComponent: () => import('./features/dashboard/dashboard.component').then((m) => m.DashboardComponent)
      },
      {
        path: 'agencies',
        canMatch: [canMatchByModule('agencies')],
        loadComponent: () =>
          import('./features/agencies/agencies-list/agencies-list.component').then((m) => m.AgenciesListComponent)
      },
      {
        path: 'agencies/create',
        loadComponent: () => import('./features/agencies/agency-form/agency-form.component').then((m) => m.AgencyFormComponent)
      },
      {
        path: 'agencies/:id/edit',
        loadComponent: () => import('./features/agencies/agency-form/agency-form.component').then((m) => m.AgencyFormComponent)
      },
      {
        path: 'agencies/:id',
        loadComponent: () =>
          import('./features/agencies/agency-detail/agency-detail.component').then((m) => m.AgencyDetailComponent)
      },
      {
        path: 'supervisors',
        canMatch: [canMatchByModule('supervisors')],
        loadChildren: () => import('./features/supervisors/supervisors.routes').then((m) => m.supervisorsRoutes)
      },
      {
        path: 'agents',
        canMatch: [canMatchByModule('agents')],
        loadComponent: () => import('./features/agents/agents-list/agents-list.component').then((m) => m.AgentsListComponent)
      },
      {
        path: 'agents/tasks',
        loadComponent: () => import('./features/agents/agents-tasks/agents-tasks.component').then((m) => m.AgentsTasksComponent)
      },
      {
        path: 'agents/create',
        loadComponent: () => import('./features/agents/agent-form/agent-form.component').then((m) => m.AgentFormComponent)
      },
      {
        path: 'agents/:id/edit',
        loadComponent: () => import('./features/agents/agent-form/agent-form.component').then((m) => m.AgentFormComponent)
      },
      {
        path: 'agents/:id',
        loadComponent: () => import('./features/agents/agent-detail/agent-detail.component').then((m) => m.AgentDetailComponent)
      },
      {
        path: 'pos',
        canMatch: [canMatchByModule('pos')],
        loadChildren: () => import('./features/pos/pos.routes').then((m) => m.posRoutes)
      },
      {
        path: 'inventory',
        canMatch: [canMatchByModule('inventory')],
        loadComponent: () => import('./features/inventory/inventory.component').then((m) => m.InventoryComponent)
      },
      {
        path: 'reports',
        canMatch: [canMatchByModule('reports')],
        loadComponent: () => import('./features/reports/reports.component').then((m) => m.ReportsComponent)
      },
      {
        path: 'alerts',
        canMatch: [canMatchByModule('alerts')],
        loadComponent: () => import('./features/alerts/alerts.component').then((m) => m.AlertsComponent)
      },
      {
        path: 'configurations',
        canMatch: [canMatchByModule('configurations')],
        loadComponent: () => import('./features/configurations/configurations.component').then((m) => m.ConfigurationsComponent)
      },
      {
        path: 'roles',
        canMatch: [canMatchByModule('roles')],
        loadComponent: () => import('./features/roles/roles.component').then((m) => m.RolesComponent)
      },
      {
        path: 'roles/create',
        canMatch: [canMatchByModule('roles')],
        loadComponent: () => import('./features/roles/roles-form.component').then((m) => m.RolesFormComponent)
      },
      {
        path: 'profile',
        canMatch: [canMatchByModule('profile')],
        loadComponent: () => import('./features/profile/profile.component').then((m) => m.ProfileComponent)
      },
      {
        path: 'btl',
        canMatch: [canMatchByModule('btl')],
        loadComponent: () => import('./features/btl/btl.component').then((m) => m.BtlComponent)
      },
      {
        path: 'logistics',
        canMatch: [canMatchByModule('logistics')],
        loadComponent: () => import('./features/logistics/logistics.component').then((m) => m.LogisticsComponent)
      },
      ...developmentRoutes
    ]
  },
  {
    path: '**',
    redirectTo: ''
  }
];
